<template>
  <div id="app">

    <div class="container">
      <nav class="navbar navbar-expand navbar-fixed-top">
          <router-link class="navbar-brand" to="/" role="button">Cast Media Art</router-link>
          <div class="navbar-collapse" id="navbarNav">
            <ul class="navbar-nav mr-auto">
              <router-link tag="li" to="/about" class="nav-item mx-2"><a class="nav-link" role="button">About</a></router-link>
              <router-link tag="li" to="/how-to" class="nav-item mx-2"><a class="nav-link" role="button">How to</a></router-link>
              <router-link tag="li" to="/check" class="nav-item mx-2"><a class="nav-link" role="button">Check cast</a></router-link>
            </ul>
          </div>
      </nav>
    </div>

    <router-view class="container"/>


    <div class="footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6 footer-column">
            <span class="copyleft">&copy;</span> 2018
          </div>

          <div class="col-lg-6 footer-column">
            <router-link class="donate-link" to="/donate" role="button">Donate</router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  .container a{
    color: #2c3e50;
  }
  .donate-link {
    color: #2c3e50;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue